module.exports = __webpack_public_path__ + "img/SystemStructure.e46f316e.svg";